import { MailPopupConfig, MailPopupType } from '../config';
import { JobPostingConfig } from './job-posting-config';

export class ProgressJobPostingConfig extends JobPostingConfig {
  public getPopupConfig(): MailPopupConfig[] {
    return [{ type: MailPopupType.JOB_CHECK }];
  }
}
